import React from "react";
import { formatBalance } from "../../../utility/moneyFormatter";

const CommissionComponent = ({ data }) => {
  return (
    <div
      style={{
        display: "flex",
        border: "1px solid #E6E6E6",
        borderRadius: "8px",
        padding: "20px",
        marginTop: "10px",
        justifyContent: "space-between",
        alignItems: "center",
      }}
    >
      <div>
        <label>From</label>
        <div
          style={{
            border: "1px solid #CBCBCB",
            borderRadius: "4px",
            padding: "5px 20px",
            fontWeight: "600",
          }}
        >
          <p>{formatBalance(Number(data.from))}</p>
        </div>

        <div style={{ marginTop: 10 }}>
          <label>To</label>
          <div
            style={{
              border: "1px solid #CBCBCB",
              borderRadius: "4px",
              padding: "5px 20px",
              fontWeight: "600",
            }}
          >
            <p>{formatBalance(Number(data.to))}</p>
          </div>
        </div>
      </div>

      <div
        style={{ height: "60px", width: "1px", backgroundColor: "#D9D9D9" }}
      />

      <div style={{ marginTop: 10, display: "flex" }}>
        <div
          style={{
            border: "1px solid #CBCBCB",
            borderRadius: "4px",
            padding: "5px 20px",
            marginRight: "10px",
            fontWeight: "500",
          }}
        >
          <p>{data.type === "PERCENTAGE" ? "%" : "₹"}</p>
        </div>
        <div
          style={{
            border: "1px solid #CBCBCB",
            borderRadius: "4px",
            padding: "5px 20px",
            fontWeight: "600",
          }}
        >
          <p>{data.value}</p>
        </div>
      </div>
    </div>
  );
};

const CommissionModal = ({ data }) => {
  return (
    <div style={{ marginTop: 30, maxHeight: 500, overflow: "auto" }}>
      {data.map((comissionObj, i) => {
        return <CommissionComponent key={i} data={comissionObj} />;
      })}
    </div>
  );
};

export default CommissionModal;
